import { render, staticRenderFns } from "./PanelCounter.vue?vue&type=template&id=bc22370e"
import script from "./PanelCounter.vue?vue&type=script&lang=js"
export * from "./PanelCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports